import Reflux from "reflux";

import Chip from "@javascript/reactComponents/lds/chips/Chip";
import { FacetSearchAffiliatedWithActions } from "@javascript/stores/actions/facetSearch/affiliatedWithActions";
import FacetSearchStore from "@javascript/stores/facetSearchStore";

const FacetSearchCriteriaEntityValues = createReactClass({
  mixins: [Reflux.connectFilter(FacetSearchStore, ({affiliation: orgListRefs}) => orgListRefs)],
  render() {
    const {orgListRefs} = this.state;

    if (!orgListRefs) return null;

    const isLocked = Boolean(
      (Zymewire.original_feed_query?.entity_list_refs ?? []).length
    );

    const orgListEntries = Object.entries(orgListRefs).flatMap(
      ([refKey, values]) =>
        values.map((value, index) => ({
          refKey,
          value,
          index,
        }))
    );

    return (
      <>
        {orgListEntries.map(({refKey, value, index}) => (
          <EntityValueEntry
            key={`${refKey}_${index}_applied_filter`}
            displayValue={value}
            locked={isLocked}
            orgListRefsKey={refKey}
          />
        ))}
      </>
    );
  }
});

const EntityValueEntry = ({ displayValue, locked, orgListRefsKey }) => {

  let removeOrgList = () => {
    if(locked) return false;
    FacetSearchAffiliatedWithActions.removeOrgListRef({ref: orgListRefsKey, display: displayValue});
    return false;
  };

  return (
    <Chip
      className="search_filter_applied_chip rspec_entity_value_result"
      label={displayValue}
      leadingIcon="attribute-search"
      size="small"
      {...!locked && {
        trailingIcon: "cancel",
        trailingIconClassName: "search_filter_applied_trailing_icon",
        trailingIconOnClick: removeOrgList,
      }}
      variant="secondary"
    />
  );
}

window.FacetSearchCriteriaEntityValues = FacetSearchCriteriaEntityValues;
export default FacetSearchCriteriaEntityValues;
